import React from 'react';
import PropTypes from 'prop-types';
import { t, translationExists } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      justifyContent: 'space-evenly',
      maxWidth: 700,
      margin: 'auto',
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 2),
      },
    },
    typography: {
      fontSize: '0.8em',
      [theme.breakpoints.up('lg')]: {
        fontSize: '1em',
      },
    },
    item: {
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(1, 0),
      },
    },
  }),
  { name: 'Abbreviations' }
);

export const Abbreviations = ({ className }) => {
  const classes = useStyles();
  const abbreviationsList = translationExists('abbreviations') ? Object.values(t('abbreviations')) : [];
  return (
    <Grid container className={clsx(classes.root, className)}>
      {abbreviationsList.map((text) => (
        <Grid item key={text} xs={6} lg={'auto'} className={classes.item}>
          <Typography className={classes.typography}>{text}</Typography>
        </Grid>
      ))}
    </Grid>
  );
};

Abbreviations.propTypes = {
  className: PropTypes.string,
};

export default Abbreviations;
